/* The action types the API scores (`GameActionType`), in the order a member
   meets them. The labels are the ones the Ranking page already shows. */
export const ACTIONS: { type: string; labelKey: string }[] = [
  { type: 'DAILY_LOGIN', labelKey: 'ranking:actions.dailyLogin' },
  { type: 'CREATE_POST', labelKey: 'ranking:actions.createPost' },
  { type: 'LIKE_POST', labelKey: 'ranking:actions.likePost' },
  { type: 'COMMENT_POST', labelKey: 'ranking:actions.commentPost' },
  { type: 'REPLY_COMMENT', labelKey: 'ranking:actions.replyComment' },
  { type: 'RECEIVE_LIKE', labelKey: 'ranking:actions.receiveLike' },
  { type: 'CREATE_EVENT', labelKey: 'ranking:actions.createEvent' },
  { type: 'PARTICIPATE_EVENT', labelKey: 'ranking:actions.participateEvent' },
  { type: 'CREATE_COURSE', labelKey: 'ranking:actions.createCourse' },
  { type: 'ENROLL_COURSE', labelKey: 'ranking:actions.enrollCourse' },
  { type: 'COMPLETE_LESSON', labelKey: 'ranking:actions.completeLesson' },
  /* F-53: the author and each person recognized; both start at 0, deleting the recognition takes them back. */
  { type: 'GIVE_RECOGNITION', labelKey: 'ranking:actions.giveRecognition' },
  { type: 'RECEIVE_RECOGNITION', labelKey: 'ranking:actions.receiveRecognition' },
  /* F-176: given when a Networking session happened (3 days after its end). */
  { type: 'NETWORKING_SESSION_HOSTED', labelKey: 'ranking:actions.networkingSessionHosted' },
  { type: 'NETWORKING_SESSION_ATTENDED', labelKey: 'ranking:actions.networkingSessionAttended' },
  { type: 'NETWORKING_REVIEW_GIVEN', labelKey: 'ranking:actions.networkingReviewGiven' },
  { type: 'NETWORKING_GROUP_SESSION_HOSTED', labelKey: 'ranking:actions.networkingGroupSessionHosted' },
  /* F-178: listening to an episode to the end (90%) and commenting on it, once per episode each. */
  { type: 'COMPLETE_EPISODE', labelKey: 'ranking:actions.completeEpisode' },
  { type: 'COMMENT_EPISODE', labelKey: 'ranking:actions.commentEpisode' },
  /* F-159: someone joined through the person's referral link (starts at 0). */
  { type: 'REFER_MEMBER', labelKey: 'ranking:actions.referMember' },
]

/** An action's label (`ranking:actions.*`), with a readable stand-in for one the app does not know yet. */
export const actionLabelKey = (type: string): string | null => ACTIONS.find((a) => a.type === type)?.labelKey ?? null
